import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleLogoClick = () => {
    if (location.pathname === '/') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      navigate('/');
    }
  };

  return (
    <header className={`fixed w-full top-0 z-50 transition-all duration-300 ${scrolled ? 'bg-black/80 backdrop-blur-lg border-b border-white/10 py-3' : 'bg-transparent py-5'}`}>
      <nav className="container mx-auto px-6 flex items-center justify-between">
        <div className="flex items-center space-x-3 cursor-pointer group" onClick={handleLogoClick}>
          <img src="https://i.imghippo.com/files/HWKq2787aqg.png" alt="Andrea Zuccarini Logo" className="h-10 md:h-12 w-auto object-contain transition-transform duration-300 group-hover:scale-105" />
          <span className="text-xl font-black tracking-tighter text-white hidden sm:block uppercase">
            BY ANDREA<span className="text-orange-500 italic">ZUCCARINI</span>
          </span>
        </div>
        <div className="flex items-center">
          <button 
            onClick={() => navigate('/survey')}
            className="bg-white/10 hover:bg-orange-500 text-white px-6 py-2 rounded-full text-xs font-black uppercase tracking-widest transition-all border border-white/10 hover:border-orange-400"
          >
            Ottieni il Kit
          </button>
        </div>
      </nav>
    </header>
  );
};

export default Header;